import { FC } from 'react';
import styled from '@emotion/styled';
import { IconAndTextButton } from '@blueprint/ui';
import { css } from '@emotion/react';

const CloseIconWithTextStyles = styled(IconAndTextButton)(
    ({ theme }) => css`
        display: flex;
        text-align: center;
        background-color: ${theme.colors.white};
        background: transparent;
        padding: 0;
        height: 44px;

        &:hover {
            background-color: ${theme.colors.white};
        }
    `
);

type CloseIconWithTextProps = {
    onClick: () => void;
    text: string;
    testId: string;
};

export const CloseIconWithText: FC<
    React.PropsWithChildren<CloseIconWithTextProps>
> = ({ onClick, text, testId }) => {
    return (
        <CloseIconWithTextStyles
            iconId="close"
            iconIdHover="close"
            iconColor="primary-brand"
            hoverColor="primary-brand"
            buttonColor="primary-brand"
            fullWidth
            content={text}
            onClick={onClick}
            testId={testId}
            backgroundColor="graphic-background-accent-light"
        />
    );
};
